import { render, staticRenderFns } from "./SimplePost.vue?vue&type=template&id=f24c6386"
import script from "./SimplePost.vue?vue&type=script&lang=js"
export * from "./SimplePost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports